
import { PageLoadHook } from "../core/PageLoadHook.mjs";

export class NavActions extends PageLoadHook {

  onPageLoad() {
    const expandables = document.querySelectorAll('.expandable');
    for (const expandable of expandables) {
      const body = expandable.querySelector('& > .expand-body');
      const bodyEmSize = body.scrollHeight / parseFloat(getComputedStyle(body).fontSize);
      body.style.setProperty("--height", bodyEmSize + "em");
    }
  }
}
